import { render, staticRenderFns } from "./SearchForUpdate.vue?vue&type=template&id=71bf3328&scoped=true"
import script from "./SearchForUpdate.vue?vue&type=script&lang=ts"
export * from "./SearchForUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bf3328",
  null
  
)

export default component.exports